import { render } from "./i-text.vue?vue&type=template&id=b399557a"
import script from "./i-text.vue?vue&type=script&lang=js"
export * from "./i-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__